import {getTopicsWiseAnalysisReport} from "../services/taxonomyService";

export const getTopicWiseAnalysisReport = (selectedExamId) => dispatch => {
    getTopicsWiseAnalysisReport(selectedExamId).then((data) => {
            // handle success
        dispatch( {
                type: 'GET_SITE_STATS',
                payload: data
            });
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'GET_SITE_STATS',
                payload: []
            });
        })

};
